module.exports = __webpack_public_path__ + "static/media/ihover.5fabedc0.svg";